<div class="grid grid-cols-1 gap-5 mt-4">
  <ng-container *ngFor="let option of fieldsData">
    <span
      class="cursor-pointer border-secondary bg-light-primary text-gray-700 inline-flex items-center justify-center gap-2 px-3 py-2 rounded-lg border text-sm font-medium transition-all hover:bg-secondary-active"
      (click)="toggleSelection(option)"
    >
      <ng-container *ngIf="!loadingCards.has(option?._id)">
        <img
          [src]="getPlatformIcon(option)"
          (error)="onImageError($event, option)"
          class="h-20px w-20px"
        />
        <span class="text-sm font-semibold text-gray-700 text-center"
          >Continue with {{ option.platformName }}</span
        >
      </ng-container>

      <div *ngIf="loadingCards.has(option?._id)" class="spinner-loader"></div>
    </span>
  </ng-container>
</div>
<!-- Divider -->
<div class="flex items-center my-4">
  <div class="flex-1 border-t border-gray-300"></div>

  <span class="px-3 text-sm text-gray-500 whitespace-nowrap">
    {{ fields?.placeholder }}
  </span>

  <div class="flex-1 border-t border-gray-300"></div>
</div>
